<template>
  <main class="page-container">
    <div class="not-found-container">
      <h1 class="not-found-title">페이지를 찾을 수 없습니다.</h1>
      <router-link to="/">
        <button class="not-found-button">홈으로</button>
      </router-link>
    </div>
  </main>
</template>

<script>
export default {
  name: "NotFoundPage"
};
</script>

<style>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
}

.not-found-title {
  font-weight: 400;
}

.not-found-button {
  border: 0;
  height: 2.75rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  background-color: var(--primary-color);
  border-radius: 4px;
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
}
</style>
